export default "<div *ngIf=\"canvas\"><canvas id=\"{{id}}\" #mycharts>{{canvas}}</canvas></div>";